import { useState } from 'react';
import { ArrowRight, Globe } from 'lucide-react';

export const MainContent = () => {
  const [url, setUrl] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (url.trim()) {
      console.log('URL submitted:', url);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="text-center space-y-8 max-w-2xl w-full">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-th-primary tracking-tight mb-8">
          HYPER PROMAX
        </h1>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex items-center space-x-3 bg-elevated border border-subtle rounded-xl p-2">
            <Globe className="w-5 h-5 text-th-secondary ml-2" />
            <input
              type="url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="Enter URL..."
              className="flex-1 bg-transparent text-th-primary placeholder-th-tertiary focus:outline-none py-2 px-2"
            />
            <button
              type="submit"
              disabled={!url.trim()}
              className="flex items-center space-x-2 px-4 py-2 bg-brand text-surface rounded-xl font-medium hover:bg-brand-hover disabled:opacity-50 disabled:cursor-not-allowed transition-all"
            >
              <ArrowRight className="w-4 h-4" />
              <span>Go</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
